export default {
      id: "fund-summary-tipbox-icon-usage",
      viewBox: "0 0 111 73",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#fund-summary-tipbox-icon",
      toString: function () {
        return this.url;
      }
    }